<div class="row">
    <div class="card card-outline card-lightblue col-md-12">
        <div class="card-header">
            <h3 class="card-title mb-0">
                <i class="fas fa-table pr-2"></i>
                Fases
            </h3>
        </div>
        <div class="card-body p-2">
            <div class="mat-elevation-z4">
                <mat-toolbar class="table-header">
                    <mat-toolbar-row>
                        <button [hidden]="visualizar" type="button" class="btn btn-primary btn-sm mr-1"
                            (click)="adicionar()">
                            <i class="far fa-file"></i> Adicionar
                        </button>
                    </mat-toolbar-row>
                </mat-toolbar>
                <table class="table table-condensed" cdkDropList (cdkDropListDropped)="onDrop($event)">
                    <thead>
                        <tr>
                            <th class="col-md-1">#</th>
                            <th class="col-md-2">Nome</th>
                            <th class="col-md-4">Descrição</th>
                            <th class="col-md-2">Qtde Dias</th>
                            <th class="col-md-3 text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let element of model.fases; let i = index">
                            <tr cdkDrag [cdkDragData]="element" cdkDragLockAxis="y">
                                <th>
                                    <div class="drag-handle">
                                        <ng-container [ngTemplateOutlet]="dragHandleTmpl">
                                        </ng-container>
                                        {{ element?.ordem }}
                                    </div>
                                </th>
                                <td>{{ element?.nome }}</td>
                                <td>{{ element?.descricao }}</td>
                                <td>{{ element?.quantidadeDias }}</td>
                                <td class="text-center"
                                    style="text-align: center; vertical-align: middle; padding: 10px">
                                    <div class="btn-group mr-1">
                                        <button [hidden]="visualizar" type="button"
                                            class="btn btn-success btn-xs text-left" (click)="editar(element?.id)">
                                            <i class="far fas fa-pen"></i>
                                        </button>
                                        <button [hidden]="visualizar" type="button"
                                            class="btn btn-danger btn-xs text-left" (click)="excluir(element?.id)">
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <ng-template #dragHandleTmpl>
                    <svg class="bi bi-list handle" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M2.5 11.5A.5.5 0 013 11h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 7h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 3h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"
                            clip-rule="evenodd" />
                    </svg>
                </ng-template>

                <h5 [hidden]="!semDados" class="table-no-data">
                    Nenhum registro encontrado.
                </h5>
                <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>